import Layout from '@layout/Index'

export const customer = [
  {
    path: '/customer',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "customer-table" */ './pages/CustomerTable.vue'),
        name: '客户列表',
        meta: {
          title: '客户列表',
        },
      },
      {
        path: 'table/type/:type',
        component: () => import(/* webpackChunkName: "customer-table" */ './pages/CustomerTable.vue'),
        meta: {
          title: '客户列表',
        },
      },
      {
        path: 'ajx/table',
        component: () => import(/* webpackChunkName: "customer-table" */ './pages/AjxCustomerTable.vue'),
        name: '爱绩效客户列表',
        meta: {
          title: '爱绩效客户列表',
        },
      },
      {
        path: 'detail/:id',
        component: () => import(/* webpackChunkName: "customer-table" */ './pages/CustomerDetail.vue'),
        name: '客户详情',
        meta: {
          title: '客户详情',
        },
      },
      {
        path: 'balance-flow/:id',
        component: () => import(/* webpackChunkName: "customer-table" */ './pages/CustomerBalanceFlowTable.vue'),
        meta: {
          title: '客户消费流水',
        }
      },
      {
        path: 'relationship/update/:id',
        component: () => import(/* webpackChunkName: "customer-relationship-form" */ './pages/CustomerRelationshipForm.vue'),
        name: '客户关系',
        meta: {
          title: '客户关系',
        },
      },
      {
        path: 'batch-table',
        component: () => import(/* webpackChunkName: "customer-batch-table" */ './pages/CustomerBatchTable.vue'),
        name: '批量客户',
        meta: {
          title: '批量客户',
        },
      },
      {
        path: 'receipt/update/:id',
        component: () => import(/* webpackChunkName: "customer-receipt-form" */ './components/CustomerReceiptForm.vue'),
        name: '开票信息',
        meta: {
          title: '开票信息',
        },
      },
      {
        path: 'customer-order-review/table',
        component: () => import(/* webpackChunkName: "customer-order-review-table" */ './pages/CustomerOrderReviewTable.vue'),
        name: '客户审单管理',
        meta: {
          title: '客户审单管理',
        },
      },
      {
        path: 'project-order-review/table',
        component: () => import(/* webpackChunkName: "project-order-review-table" */ './pages/ProjectOrderReviewTable.vue'),
        name: '项目审单管理',
        meta: {
          title: '项目审单管理',
        },
      },
      {
        path: 'batch-order-review/table',
        component: () => import(/* webpackChunkName: "batch-order-review-table" */ './pages/BatchOrderReviewTable.vue'),
        name: '批次审单管理',
        meta: {
          title: '批次审单管理',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/customer/customer.route.js